var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "url(#paint0_linear_20560_6654)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4458 35.44C27.4458 33.92 27.8258 32.5267 28.5858 31.26C29.3458 29.9933 30.3858 29 31.7058 28.28C32.3591 27.9333 32.8724 27.4267 33.2458 26.76C33.6191 26.08 33.8058 25.3333 33.8058 24.52C33.8058 23.7467 33.6124 23.0467 33.2258 22.42C32.8524 21.78 32.3458 21.28 31.7058 20.92C31.0658 20.5467 30.3658 20.36 29.6058 20.36C28.8324 20.36 28.1258 20.5467 27.4858 20.92C26.8458 21.28 26.3391 21.78 25.9658 22.42C25.5924 23.0467 25.4058 23.7467 25.4058 24.52H20.5258C20.5258 22.8533 20.9324 21.34 21.7458 19.98C22.5591 18.6067 23.6524 17.5133 25.0258 16.7C26.4124 15.8867 27.9391 15.48 29.6058 15.48C31.2724 15.48 32.7924 15.8867 34.1658 16.7C35.5391 17.5133 36.6324 18.6067 37.4458 19.98C38.2724 21.34 38.6858 22.8533 38.6858 24.52C38.6858 26.2267 38.2658 27.8 37.4258 29.24C36.5991 30.68 35.4591 31.7933 34.0058 32.58C33.4858 32.86 33.0724 33.2533 32.7658 33.76C32.4724 34.2667 32.3258 34.8267 32.3258 35.44H27.4458ZM30.0658 44.52C29.3591 44.52 28.7591 44.2733 28.2658 43.78C27.7858 43.2867 27.5458 42.6867 27.5458 41.98C27.5458 41.2867 27.7858 40.7 28.2658 40.22C28.7591 39.74 29.3591 39.5 30.0658 39.5C30.7591 39.5 31.3458 39.74 31.8258 40.22C32.3058 40.7 32.5458 41.2867 32.5458 41.98C32.5458 42.6867 32.3058 43.2867 31.8258 43.78C31.3458 44.2733 30.7591 44.52 30.0658 44.52Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20560_6654",
    x1: 60,
    y1: -0.00000217557,
    x2: -6.5,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D71E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F069DE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/QuestionMark.8265e116797e55e6c1791f825922bd20.svg";
export { ForwardRef as ReactComponent };